import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/story", label: "剧情进展" },
  { to: "/chapters", label: "追更话数" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 shadow-[0_1px_0_0_oklch(var(--background-200))] backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5" aria-label="斗罗漫报 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-sword-fill text-lg" />
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            斗罗<span className="text-accent-500">漫报</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => {
            const active = pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  solid
                    ? active
                      ? "text-primary-600"
                      : "text-foreground-700 hover:text-primary-600"
                    : active
                      ? "text-background-50"
                      : "text-background-100/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            solid ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <div className="flex flex-col gap-1 pt-2">
            {navLinks.map((link) => {
              const active = pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`rounded-md px-3 py-3 text-sm font-medium ${
                    active
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}